import styled from 'styled-components/native'

import { ThemeType } from '../../utils/themes/ThemeProvider'

export const AuroraIconCircle = styled.View<{ theme: ThemeType }>(({ theme }) => ({
  width: 48,
  height: 48,
  borderRadius: 24,
  backgroundColor: theme.colors.secondaryIconButtonBackgroundDefault,
  borderWidth: 1,
  borderColor: theme.colors.secondaryIconButtonOutlineDefault,
  justifyContent: 'center',
  alignItems: 'center',
}))
